// extracted by mini-css-extract-plugin
export default {"container":"footer_container__snxui","subscribe":"footer_subscribe__VtZn5","links":"footer_links__XxHqf"};